import React, { useState } from 'react';
import SelectComponent from '../../components/form/select';
import InputBase from '@material-ui/core/InputBase';
import Grid from '@material-ui/core/Grid';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as ApexSearchIcon } from 'assets/icons/search.svg';
import { ReactComponent as ApexFilterIcon } from 'assets/icons/filter-icon.svg';
import { ReactComponent as SelectIcon } from 'assets/icons/select-icon.svg';
import styles from './style';
import { searchModel } from "./searchModel";

const SearchGroup = (props: searchModel) => {
	const { search } = props;
	const { groupSearchWrapper, searchIcon, filterGroup, filterIconSelect } = styles();
	const [order, setOrder] = React.useState(0);
	const [searchText, setSearchText] = useState('');

	const handleOrderChange = (e: any) => {
		setOrder(e.target.value);
		search(searchText, e.target.value);
	};

	const handleSearchChange = (e: any) => {
		const { value } = e.target;
		setSearchText(value);
		search(value, order);
	};

	return (
		<Grid container spacing={2}  direction="row" justifyContent="flex-end" alignItems="flex-end">
			<Grid item>
				<SelectComponent
					label="Sort order"
					name="sortOrder"
					value={order}
					items={[
						{ id: 0, name: 'Ascending' },
						{ id: 1, name: 'Descending' }
					]}
					onChange={(event: any) => handleOrderChange(event)}
					required={false}
				/>
			</Grid>
			<Grid item >
				<div className={groupSearchWrapper}>
					<SvgIcon className={searchIcon}>
						<ApexSearchIcon />
					</SvgIcon>
					<InputBase
						name="searchTerm"
						placeholder={`Search by name`}
						autoComplete="off"
						classes={{
							root: 'inputRoot',
							input: 'inputText'
						}}
						inputProps={{ 'aria-label': 'search' }}
						onChange={handleSearchChange}
						value={searchText}
					/>
				</div>
			</Grid>
			<Grid item>
				<div className={filterGroup}>
					<SvgIcon>
						<ApexFilterIcon />
					</SvgIcon>
					<SvgIcon className={filterIconSelect}>
						<SelectIcon />
					</SvgIcon>
				</div>
			</Grid>
		</Grid>
	);
};

export default SearchGroup;
